import { OnInit, Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ModalController } from '@ionic/angular';
import { SensorLimitBaseComponent } from './sensor-limit-base.component';
import { DevicesService } from '../../../views/main/intranet/devices/devices.service';
import { LimitType } from '@models/device';
import { LimitService } from '@shared/services/limit.services';

@Component({
  standalone: false,
  selector: 'app-sensor-range',
  templateUrl: './sensor-range.component.html',
  styleUrls: ['./sensor-limit.component.scss']
})
export class SensorRangeComponent extends SensorLimitBaseComponent implements OnInit {

  constructor(
    devicesService: DevicesService,
    toastService: ToastService,
    modalCtrl: ModalController,
    limitService: LimitService

  ) {
    super(devicesService, toastService, modalCtrl, limitService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.type = LimitType.RANGE;
    if (this.isEdit()) {
      this.form = new UntypedFormGroup({
        name: new UntypedFormControl(this.data.name, [Validators.required]),
        property: new UntypedFormControl(this.data.property, [Validators.required]),
        minValue: new UntypedFormControl(this.data.minValue, [Validators.required]),
        maxValue: new UntypedFormControl(this.data.maxValue, [Validators.required]),
        isVisible: new UntypedFormControl(this.data.isVisible),
        colorCode: new UntypedFormControl(this.data.colorCode)
      },
        { validators: this.minLessThanMaxValidator() });
    } else {
      this.form = new UntypedFormGroup({
        name: new UntypedFormControl(null, [Validators.required]),
        property: new UntypedFormControl(null, [Validators.required]),
        minValue: new UntypedFormControl(null, [Validators.required]),
        maxValue: new UntypedFormControl(null, [Validators.required]),
        isVisible: new UntypedFormControl(true),
        colorCode: new UntypedFormControl("#000")
      },
        { validators: this.minLessThanMaxValidator() });
    }
  }

  selectOption(event): void {
    let selectedAttribute = event.value;
    this.form.value.property = selectedAttribute;
  }

  checkValues(): boolean {
    if (!this.form) {
      console.error('El formulario no está inicializado.');
      return false;
    }
    return this.form.valid;
  }

  minLessThanMaxValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const min = formGroup.get('minValue')?.value;
      const max = formGroup.get('maxValue')?.value;

      if (min != null && max != null && min >= max) {
        return { minGreaterOrEqualMax: true };
      }

      return null;
    };
  }
}